import './identifier-input.scss'
import { defineComponent } from 'vue'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'

import { Item, Movement, LinkableItemLifecycleStates } from '@skinsoft/types'
import { itemSelectors, movementSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { StateInput, ValidationStates } from '@skinsoft/ui'

export const BAR_CODE_READER_CLICK = 'barcode-reader-click'

export const IdentifierInput = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sStateInput: StateInput,
    },
    props: ['item', 'movement'],
    template: require('./identifier-input.html'),
    data() {
        return {
            ValidationStates,
            barCodeIcon: faBarcode,
            itemSelectors,
        }
    },
    mounted() {
        this.syncLinkableItemState()
    },
    computed: {
        identifier(): ReturnType<typeof itemSelectors.identifier> {
            return itemSelectors.identifier(this.item, this.getAppLocale());
        },
        linkableItemState(): ReturnType<typeof movementSelectors.linkableItemState> {
            return movementSelectors.linkableItemState(this.movement, this.item.id);
        },
        shouldDisplayBarCodeReader(): boolean {
            return this.linkableItemState === LinkableItemLifecycleStates.SELECTED
        },
    },
    methods: {
        async validator(value: string) {
            const isValid = value === this.identifier;

            if (!isValid) {
                return false;
            }

            if (this.linkableItemState !== LinkableItemLifecycleStates.SELECTED) {
                // the item has already been transitionned and this is just a first render round trip
                return true;
            }

            try {
                await this.$movementDataStore.transitionLinkableItem(
                    movementSelectors.id(this.movement),
                    itemSelectors.id(this.item),
                    LinkableItemLifecycleStates.IN_TRANSIT,
                );
                return true;
            } catch (error) {
                return false;
            }
        },
        syncLinkableItemState() {
            const stateInput = this.$refs.stateInput as InstanceType<typeof StateInput>
            if (!stateInput) {
                // for some reason it is undefined for a while after mount
                return;
            }

            switch (this.linkableItemState) {
                case LinkableItemLifecycleStates.FINALIZED:
                case LinkableItemLifecycleStates.IN_TRANSIT:
                    stateInput.validate(this.identifier);
                    break;
                case LinkableItemLifecycleStates.SELECTED:
                    stateInput.reset();
                    break;
            }
        },
        openBarCodeReader() {
            if (this.shouldDisplayBarCodeReader) {
                this.emitOnBus(BAR_CODE_READER_CLICK)
            }
        },
    },
    watch: {
        linkableItemState: {
            handler() {
                this.syncLinkableItemState()
            },
            immediate: false,
            deep: true,
        },
    },
})
